// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Bus from './bus'
import FastClick from 'fastclick'
import router from '@/router/index.js'
import App from './App'
import store from '@/store/index.js'

// import vConsole from '../static/vconsole.main.js'

// var vvConsole=new vConsole();
FastClick.attach(document.body)

Vue.config.productionTip = false
Vue.prototype.$bus = Bus

/* eslint-disable no-new */
new Vue({
  router,
  store,
  //vvConsole,
  render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js